import { CmsImageForUrl } from "src/components/images/CmsImageForUrl";
import PlaySvg from 'src/components/svg/PlaySvg';
import { MovieClip } from 'src/lib/movieinfo/movieinfotypes';
import styled from 'src/lib/styles/css';


//#region [Props]
type RelatedClipProps = {
	clip: MovieClip;
	onClick: () => void;
};
//#endregion

//#region [Component]
export default function RelatedClip({ clip, onClick }: RelatedClipProps) {
	return <SRelatedClip onClick={onClick}>
		<SImageSizer>
			{clip.sanityImageWideUrl && <CmsImageForUrl imageUrl={clip.sanityImageWideUrl} width={200} alt={clip.clipTitle!}/>}
			<SPlaySvg />
		</SImageSizer>
		<SClipTitle>{clip.clipTitle}</SClipTitle>
	</SRelatedClip>;
}
//#endregion

//#region [Styles]
const SRelatedClip = styled.article`
	max-width: 200px;
	width: 40vw;
	margin: 0;
	border-radius: 0;
	position: relative;

	&:hover {
		cursor: pointer;
	}

	@supports not (column-gap: 30px) {
		&:not(:first-child) {
			margin-left: 10px;
			@media (min-width: 550px) {
				margin-left: 30px;
			}
		}
	}
`;

const SImageSizer = styled.div`
	overflow: hidden;
	border-radius: 4px;

`;

const SPlaySvg = styled(PlaySvg)`
	width: 30%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

const SClipTitle = styled.h1`
	font-size: 12px;
	background: none;
	padding: 0;
	font-weight: normal;

	@media (min-width: 550px) {
        /*@media (orientation: landscape) {*/
        font-size: 16px;
    }
`;
//#endregion